import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PruHttpService } from '../../../services/pru-http.service';
import { GenericService } from '../../../services/generic.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../services/pru-http.service";
import * as i2 from "../../../services/generic.service";
var AccountsService = /** @class */ (function () {
    function AccountsService(pruHttpService, genericService) {
        this.pruHttpService = pruHttpService;
        this.genericService = genericService;
        this.defaultBaseApiUrl = '/api/co/secure/myaccounts/v2/accountsummary';
    }
    AccountsService.prototype.getAccounts = function (productType, clearCache) {
        if (clearCache === void 0) { clearCache = true; }
        var apiUrl = this.defaultBaseApiUrl + "?buName=" + productType;
        if (clearCache) {
            apiUrl = apiUrl + "&clearcache=" + this.genericService.xPruId;
        }
        return this.pruHttpService.get(apiUrl, 'AccountsService').pipe(catchError(function (err) { return of(err.error); }));
    };
    AccountsService.ngInjectableDef = i0.defineInjectable({ factory: function AccountsService_Factory() { return new AccountsService(i0.inject(i1.PruHttpService), i0.inject(i2.GenericService)); }, token: AccountsService, providedIn: "root" });
    return AccountsService;
}());
export { AccountsService };
